import { Theme } from '@mui/material/styles';

export const footer = (theme: Theme) => ({
    backgroundColor: 'footer.main',
    minHeight: theme.footerHeight,
    marginTop: theme.spacing(15),
    paddingY: theme.spacing(2.5),
    color: 'footerText.main',
    boxShadow: 'none',
}) as const;

export const menu = (theme: Theme) => ({
    [theme.breakpoints.up('lg')]: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: theme.spacing(1.875),
        marginBottom: theme.spacing(10),
        marginX: 0,
    },
}) as const;

export const accordion = (theme: Theme) => ({
    backgroundColor: 'transparent',

    '&::before': {
        display: 'none',
    },

    [theme.breakpoints.up('lg')]: {
        '& .MuiCollapse-root': {
            height: 'auto',
            visibility: 'initial',
        },
    },
}) as const;

export const accordionSummary = (theme: Theme) => ({
    paddingX: 0,
    color: 'footerTitle.main',
    textTransform: 'uppercase',
    fontSize: 14,

    [theme.breakpoints.up('lg')]: {
        pointerEvents: 'none',
    },

    '& .MuiAccordionSummary-expandIconWrapper': {
        color: 'footerIcon.main',

        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },
}) as const;

export const accordionDetails = (theme: Theme) => ({
    padding: 0,
    paddingBottom: theme.spacing(1.5),
}) as const;

export const menuList = {
    padding: 0,
} as const;

export const menuItem = (theme: Theme) => ({
    backgroundColor: 'transparent !important',
    cursor: 'default',
    marginTop: theme.spacing(0.375),
    padding: 0,
    minHeight: 'auto',
}) as const;

export const menuLink = {
    color: 'footerNav.main',
    fontSize: 13,
} as const;

export const divider = {
    backgroundColor: 'footerDivider.main',
    border: 'none',
    height: '1px',
} as const;

export const copyright = (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    marginY: theme.spacing(1.25),
    fontSize: 11,

    [theme.breakpoints.up('lg')]: {
        flexDirection: 'row',
        marginTop: theme.spacing(1.875),
        marginBottom: 0,
    },
}) as const;

export const copyrightItem = (theme: Theme) => ({
    display: 'flex',
    marginTop: theme.spacing(1.875),
    marginRight: 0,

    [theme.breakpoints.up('lg')]: {
        marginTop: 0,
        marginRight: theme.spacing(4),
    },
}) as const;

export const link = {
    color: 'footerLink.main',
    fontSize: 11,
} as const;
